import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

export const companyUsersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/company/users',
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('./users').then((d) => d.Route))
